module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', [_c('loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [(_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.successMessage) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n        " + _vm._s(_vm.successMessage) + "\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.choosePassword) ? _c('fieldset', [_c('legend', [_vm._v("Recuperar Senha")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n          Para recuperar a senha, precisamos do seu email. Será enviado um link para que você possa trocá-la.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.askReset
    }
  }, [_vm._v("Recuperar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Voltar")])]) : _vm._e(), _vm._v(" "), (_vm.choosePassword) ? _c('fieldset', [_c('legend', [_vm._v("Escolher Senha")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n          Escolha uma nova senha para sua conta\n        ")]), _vm._v(" "), _c('form', {
    staticClass: "form-group",
    attrs: {
      "action": _vm.passwordChangeURL,
      "method": "POST"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "new_password"
    }
  }, [_vm._v("Nova Senha")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "new_password",
      "name": "new_password",
      "type": "password",
      "placeholder": "Nova Senha"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.token),
      expression: "token"
    }],
    staticClass: "sr-only",
    attrs: {
      "id": "token",
      "name": "token"
    },
    domProps: {
      "value": (_vm.token)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.token = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.username),
      expression: "user.username"
    }],
    staticClass: "sr-only",
    attrs: {
      "id": "username",
      "name": "username",
      "type": "password"
    },
    domProps: {
      "value": (_vm.user.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("Confirmar")])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70b883af"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PasswordReset.vue
// module id = 1458
// module chunks = 1